export const ROOT_URI = '/agent/agentDocumentation';

export default {
  DIRECT_DEPOSIT_INFORMATION: `${ROOT_URI}/directDepositInformation`,
  LEGAL_DOCUMENT: (docId: string) => `${ROOT_URI}/accounts/${docId}`,
  ALL_APP_AND_ENROLL_MY_WAY: `${ROOT_URI}/allAppAndEnrollMyWay`,
  PRODUCER_COMPLIANCE_POLICY: `${ROOT_URI}/producerCompliancePolicy`,
};
